import $ from "jquery";

if (document.querySelector(".cta-banner-headline")) {
    $(".cta-banner-headline__slider").slick({
        arrows: false,
        dots: true,
        appendDots: $(".cta-banner-headline__slider-dots")
    });
}